import { ChannelMetric } from 'lib-dashboard-types';
import { Media } from 'lib-shared-types-channels';
import { memo, useMemo } from 'react';

import { DashboardCard } from 'app/views/layout/views/dashboard/components/card';
import { mediaToChannels } from 'utils/channels';

import {
  ChannelDashboardChannelContext,
  ChannelDashboardChannelContextValue,
} from './channelDashboardChannel.context';
import { ChannelDashboardChannelActions } from './components/actions/channelDashboardChannelActions';
import { ChannelDashboardMetrics } from './components/metrics/channelDashboardMetrics';
import { ChannelDashboardChannelTitle } from './components/title/channelDashboardChannelTitle';

type ChannelDashboardChannelProps = {
  /** The channel media type. */
  media: Media;
  /** The metric data for the current channel media. */
  metrics?: ChannelMetric;
  /** Whether to show the skeleton UI, e.g. when loading. */
  isSkeleton: boolean;
};

export const ChannelDashboardChannel = memo(function ChannelDashboardChannel({
  media,
  metrics,
  isSkeleton,
}: ChannelDashboardChannelProps): JSX.Element {
  const channels = useMemo(() => mediaToChannels[media], [media]);

  const contextValue: ChannelDashboardChannelContextValue = useMemo(
    () => ({
      media,
      channels,
      metrics,
      isSkeleton,
    }),
    [channels, isSkeleton, media, metrics],
  );

  return (
    <ChannelDashboardChannelContext.Provider value={contextValue}>
      <DashboardCard
        key={media}
        titleSlot={<ChannelDashboardChannelTitle />}
        actionsSlot={<ChannelDashboardChannelActions />}
      >
        <ChannelDashboardMetrics />
      </DashboardCard>
    </ChannelDashboardChannelContext.Provider>
  );
});
